function LoadingPanel({ message = "Loading", subtext = "Preparing the latest information", className = "" }) {
  return (
    <div className={`rounded-2xl border border-border bg-card/80 p-8 text-center shadow-sm ${className}`}>
      <div className="mx-auto h-14 w-14 rounded-full border border-border bg-background flex items-center justify-center relative">
        <div className="absolute inset-0 rounded-full border-2 border-transparent border-t-accent border-r-primary animate-spin" />
        <div className="h-7 w-7 rounded-xl bg-primary text-primary-foreground flex items-center justify-center font-display text-sm font-black">
          Q
        </div>
      </div>
      <p className="mt-4 font-display text-base font-semibold text-foreground">{message}</p>
      <p className="mt-1 text-sm text-muted-foreground">{subtext}</p>
      <div className="mt-5 flex items-center justify-center gap-2">
        <span className="h-1.5 w-1.5 rounded-full bg-primary animate-pulse" />
        <span className="h-1.5 w-7 rounded-full bg-accent/70 animate-pulse [animation-delay:150ms]" />
        <span className="h-1.5 w-1.5 rounded-full bg-primary/40 animate-pulse [animation-delay:300ms]" />
      </div>
    </div>
  );
}

export function InlineLoader({ message = "Loading", subtext = "Preparing the latest information", className = "" }) {
  return <LoadingPanel message={message} subtext={subtext} className={className} />;
}

export function CardSkeleton({ message = "Loading details", subtext, className = "" }) {
  return <LoadingPanel message={message} subtext={subtext} className={className} />;
}

export function TableSkeleton({ rows = 5 }) {
  return <LoadingPanel message="Loading records" subtext={`Preparing ${rows} rows`} />;
}

export function QueueSkeleton() {
  return <LoadingPanel message="Loading queue" subtext="Refreshing patient status" />;
}

export function StatsSkeleton() {
  return <LoadingPanel message="Loading stats" subtext="Calculating today's numbers" />;
}
